import { render, staticRenderFns } from "./EditRoomComponent.vue?vue&type=template&id=639f9633&scoped=true&"
import script from "./EditRoomComponent.vue?vue&type=script&lang=js&"
export * from "./EditRoomComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639f9633",
  null
  
)

export default component.exports